@if (
  fieldSet.includes(ServiceDataFields.AdditionalPatientInformation) &&
  (canViewAdditionalPatientInformationSection$ | async)
) {
  <section
    [attr.data-cy]="ServiceDataFields.AdditionalPatientInformation + '-section'"
  >
    <p class="caption mb-1">
      {{ 'serviceData.form.additionalPatientInformation' | translate }}
    </p>
    <hr class="mt-0" />
    <ng-container formGroupName="shared">
      <ng-container formGroupName="patientInformation">
        @if (
          fieldSet.includes(ServiceDataFields.Height) ||
          fieldSet.includes(ServiceDataFields.Weight)
        ) {
          <div
            class="row"
            *appRequirePermission="id ? ['medicalInformation'] : []"
          >
            @if (fieldSet.includes(ServiceDataFields.Height)) {
              <div class="col-12 col-md-6 mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-sm-4 mb-1">
                    <label for="height">{{
                      'serviceData.form.height' | translate
                    }}</label>
                  </div>
                  <div class="col-12 col-sm-8">
                    <input
                      class="form-control"
                      formControlName="height"
                      id="height"
                      type="number"
                      appInputValidationStatus
                      [attr.data-cy]="ServiceDataFields.Height + '-input'"
                      [placeholder]="
                        'serviceData.form.placeholders.height' | translate
                      "
                    />
                  </div>
                </div>
                <div class="row justify-content-end">
                  <div class="col-12 col-sm-8">
                    <app-validation-error
                      for="height"
                      translations="validation.generic"
                      [attr.data-cy]="
                        ServiceDataFields.Height + '-validation-error'
                      "
                    ></app-validation-error>
                  </div>
                </div>
              </div>
            }

            @if (fieldSet.includes(ServiceDataFields.Weight)) {
              <div class="col-12 col-md-6 mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-sm-4 mb-1">
                    <label for="weight">{{
                      'serviceData.form.weight' | translate
                    }}</label>
                  </div>
                  <div class="col-12 col-sm-8">
                    <input
                      class="form-control"
                      formControlName="weight"
                      id="weight"
                      type="number"
                      appInputValidationStatus
                      [attr.data-cy]="ServiceDataFields.Weight + '-input'"
                      [placeholder]="
                        'serviceData.form.placeholders.weight' | translate
                      "
                    />
                  </div>
                </div>
                <div class="row justify-content-end">
                  <div class="col-12 col-sm-8">
                    <app-validation-error
                      for="weight"
                      translations="validation.generic"
                      [attr.data-cy]="
                        ServiceDataFields.Weight + '-validation-error'
                      "
                    ></app-validation-error>
                  </div>
                </div>
              </div>
            }
          </div>

          @if (highBMI$ | async) {
            <div
              class="row justify-content-end mx-1 mb-3"
              *appRequirePermission="id ? ['medicalInformation'] : []"
            >
              <div class="notes col-12 col-md-10" data-cy="highBMI-note">
                {{ 'serviceData.form.highBMI' | translate }}
              </div>
            </div>
          }
        }
        @if (fieldSet.includes(ServiceDataFields.DocumentNumber)) {
          <div class="row" *appRequirePermission="'serviceData.documentNumber'">
            <div class="col-12 col-md-6 mb-3">
              <div class="row align-items-center">
                <div class="col-12 col-sm-4 mb-1">
                  <label for="documentNumber">{{
                    'serviceData.form.documentNumber' | translate
                  }}</label>
                </div>
                <div class="col-12 col-sm-8">
                  <input
                    class="form-control"
                    formControlName="documentNumber"
                    id="documentNumber"
                    appInputValidationStatus
                    [attr.data-cy]="ServiceDataFields.DocumentNumber + '-input'"
                    [placeholder]="
                      'serviceData.form.placeholders.documentNumber' | translate
                    "
                  />
                </div>
              </div>
              <div class="row justify-content-end">
                <div class="col-12 col-sm-8">
                  <app-validation-error
                    for="documentNumber"
                    translations="validation.generic"
                    [attr.data-cy]="
                      ServiceDataFields.DocumentNumber + '-validation-error'
                    "
                  ></app-validation-error>
                </div>
              </div>
            </div>
          </div>
        }
      </ng-container>
    </ng-container>
    @if (
      fieldSet.includes(ServiceDataFields.PatientGender) ||
      fieldSet.includes(ServiceDataFields.Relationship)
    ) {
      <div class="row" *appRequirePermission="id ? ['medicalInformation'] : []">
        @if (fieldSet.includes(ServiceDataFields.PatientGender)) {
          <ng-container formGroupName="shared">
            <div class="col-12 col-md-6 mb-3">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-4 mb-1">
                  <label>{{
                    'serviceData.form.patientGender' | translate
                  }}</label>
                </div>
                <div class="col-12 col-sm-6 col-md-8">
                  <div class="form-check form-check-inline form-check-lg">
                    <input
                      id="genderMale"
                      class="form-check-input me-2"
                      type="radio"
                      formControlName="patientGender"
                      [attr.data-cy]="
                        ServiceDataFields.PatientGender +
                        '-radio-' +
                        Gender.Male
                      "
                      [value]="Gender.Male"
                    />
                    <label class="form-check-label" for="genderMale">
                      Male
                    </label>
                  </div>
                  <div class="form-check form-check-inline form-check-lg">
                    <input
                      id="genderFemale"
                      class="form-check-input me-2"
                      type="radio"
                      formControlName="patientGender"
                      [attr.data-cy]="
                        ServiceDataFields.PatientGender +
                        '-radio-' +
                        Gender.Female
                      "
                      [value]="Gender.Female"
                    />
                    <label class="form-check-label" for="genderFemale">
                      Female
                    </label>
                  </div>
                </div>
              </div>
              <div class="row justify-content-end">
                <div class="col-12 col-sm-6 col-md-8">
                  <app-validation-error
                    for="patientGender"
                    translations="validation.generic"
                    [attr.data-cy]="
                      ServiceDataFields.PatientGender + '-validation-error'
                    "
                  ></app-validation-error>
                </div>
              </div>
            </div>
          </ng-container>
        }
        @if (fieldSet.includes(ServiceDataFields.Relationship)) {
          <ng-container formGroupName="paternity">
            <div class="col-12 col-md-6 mb-3">
              <div class="row align-items-center">
                <div class="col-12 col-sm-4 mb-1">
                  <label for="relationship-select">{{
                    'serviceData.form.participants.relationship' | translate
                  }}</label>
                </div>
                <div class="col-12 col-sm-8">
                  <app-select
                    class="w-100"
                    id="relationship-select"
                    formControlName="relationship"
                    [attr.data-cy]="ServiceDataFields.Relationship + '-select'"
                    [placeholder]="
                      'serviceData.form.participants.relationshipPlaceholder'
                        | translate
                    "
                  >
                    @for (relationship of relationships; track relationship) {
                      <app-select-option
                        [value]="relationship"
                        [label]="
                          'serviceData.relationship.' + relationship | translate
                        "
                      />
                    }
                  </app-select>
                </div>
              </div>
              <div class="row justify-content-end">
                <div class="col-12 col-sm-8">
                  <app-validation-error
                    for="relationship"
                    translations="validation.generic"
                    [attr.data-cy]="
                      ServiceDataFields.Relationship + '-validation-error'
                    "
                  />
                </div>
              </div>
            </div>
          </ng-container>
        }
      </div>
    }
    @if (fieldSet.includes(ServiceDataFields.Ethnicity)) {
      <!-- Own row, "Other" ethnicity adds a free text input next to the select -->
      <div class="row" *appRequirePermission="id ? ['medicalInformation'] : []">
        <ng-container formGroupName="shared">
          <div class="col-12 col-md-6 mb-3" formGroupName="patientInformation">
            <div class="row align-items-center">
              <div class="col-12 col-sm-4 mb-1">
                <label for="ethnicity-select">{{
                  'serviceData.form.ethnicity' | translate
                }}</label>
              </div>
              <div class="col-12 col-sm-8">
                <app-select
                  class="w-100"
                  id="ethnicity-select"
                  formControlName="ethnicitySelect"
                  [attr.data-cy]="ServiceDataFields.Ethnicity + '-select'"
                  [placeholder]="
                    'serviceData.form.placeholders.ethnicity' | translate
                  "
                >
                  @for (type of Object.keys(Ethnicity); track type) {
                    <app-select-option
                      [value]="type"
                      [label]="'serviceData.ethnicity.' + type | translate"
                    />
                  }
                </app-select>
              </div>
            </div>
            <div class="row justify-content-end">
              <div class="col-12 col-sm-8">
                <app-validation-error
                  for="ethnicity"
                  translations="validation.generic"
                  [attr.data-cy]="
                    ServiceDataFields.Ethnicity + '-validation-error'
                  "
                ></app-validation-error>
              </div>
            </div>
          </div>
          @if (showEthnicityInput()) {
            <div
              class="col-12 col-md-6 mb-3"
              formGroupName="patientInformation"
            >
              <div class="row align-items-center">
                <div class="col-12">
                  <input
                    class="form-control"
                    formControlName="ethnicity"
                    id="ethnicity"
                    appInputValidationStatus
                    [attr.data-cy]="ServiceDataFields.Ethnicity + '-input'"
                    [placeholder]="
                      'serviceData.form.placeholders.ethnicity' | translate
                    "
                  />
                </div>
              </div>
            </div>
          }
        </ng-container>
      </div>
    }
    @if (fieldSet.includes(ServiceDataFields.PatientAddress)) {
      <ng-container formGroupName="shared">
        <div
          formGroupName="patientInformation"
          *appRequirePermission="id ? ['patientInformation'] : []"
          [attr.data-cy]="ServiceDataFields.PatientAddress + '-section'"
        >
          <p class="label mb-2">
            {{ 'serviceData.form.address.title' | translate }}
          </p>
          <div class="row" formGroupName="address">
            @for (field of addressFields; track field) {
              <div class="col-12 col-md-6 mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-sm-4 mb-1">
                    <label [for]="'address-' + field">{{
                      'serviceData.form.address.' + field | translate
                    }}</label>
                  </div>
                  <div class="col-12 col-sm-8">
                    <input
                      class="form-control"
                      [formControlName]="field"
                      [id]="'address-' + field"
                      appInputValidationStatus
                      [attr.data-cy]="
                        ServiceDataFields.PatientAddress +
                        '-' +
                        field +
                        '-input'
                      "
                      [placeholder]="
                        'serviceData.form.address.placeholders.' + field
                          | translate
                      "
                    />
                  </div>
                </div>
                <div class="row justify-content-end">
                  <div class="col-12 col-sm-8">
                    <app-validation-error
                      [for]="field"
                      translations="validation.generic"
                      [attr.data-cy]="
                        ServiceDataFields.PatientAddress +
                        '-' +
                        field +
                        '-validation-error'
                      "
                    ></app-validation-error>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </ng-container>
    }
  </section>
}
